export const NEOMOD_SCORE = {
  masterTableName: "MC_NEOMOD_SCORE",
  tableName: "MC_NEOMOD_SCORE_DET",
  columnName: "NS_ID",
  columnValue: 0,
  title: "neomod.score",
  rows: [
    { title: "id", value: "ID" },
    { title: "date", value: "PROCESS_TIME", type: "date" },
    { title: "CUSER", value: "CUSER" },
    { title: "calc_value", value: "CALC_VALUE" },
    { title: "mortality_ratio", value: "MORTALITY_RATIO" },
    {
      title: "central_nervous_system",
      value: "CENTRAL_NERVOUS_SYSTEM__XNAME",
    },
    {
      title: "hemocoagulation_balance",
      value: "HEMOCOAGULATION_BALANCE_XNAME",
    },
    { title: "respiratory_system", value: "RESPIRATORY_SYSTEM_ID_XNAME" },
    {
      title: "gastrointestinal_system",
      value: "GASTROINTESTINAL_SYSTEM_XNAME",
    },
    {
      title: "cardiovascular_system",
      value: "CARDIOVASCULAR_SYSTEM_I_XNAME",
    },
    { title: "renal_system", value: "RENAL_SYSTEM_ID_XNAME" },
    { title: "acid_base_balance", value: "ACID_BASE_BALANCE_ID_XNAME" },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "CUSER", headerName: "createdby", flex: 1 },
    {
      field: "calc_value",
      headerName: "neomod.puan",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        const val = Number(row.CALC_VALUE) || 0;
        return val;
      },
    },
    {
      field: "mortality_ratio",
      headerName: "neomod.morale-rate",
      flex: 1,
    },
    {
      field: "central_nervous_system",
      headerName: "neomod.virtual-neural-parameters",
      flex: 1,
    },
    {
      field: "hemocoagulation_balance",
      headerName: "neomod.hemocoagulation-balance",
      flex: 1,
    },
    {
      field: "respiratory_system",
      headerName: "neomod.respiratory-system",
      flex: 1,
    },
    {
      field: "gastrointestinal_system",
      headerName: "neomod.gastrointestinal-system",
      flex: 1,
    },
    {
      field: "cardiovascular_system",
      headerName: "neomod.cardiovascular-system",
      flex: 1,
    },
    {
      field: "renal_system",
      headerName: "neomod.risk-area-skin-type",
      flex: 1,
    },
    {
      field: "acid_base_balance",
      headerName: "neomod.acid-base",
      flex: 1,
    },
  ],
  mcpConfig: {
    CENTRAL_NERVOUS_SYSTEM_ID: {
      mcpId: 647,
      field: "CENTRAL_NERVOUS_SYSTEM_ID",
      scoreField: "CENTRAL_NERVOUS_SYSTEM_ID",
    },
    HEMOCOAGULATION_BALANCE_ID: {
      mcpId: 648,
      field: "HEMOCOAGULATION_BALANCE_ID",
      scoreField: "HEMOCOAGULATION_BALANCE_ID",
    },
    RESPIRATORY_SYSTEM_ID: {
      mcpId: 649,
      field: "RESPIRATORY_SYSTEM_ID",
      scoreField: "RESPIRATORY_SYSTEM_ID",
    },
    GASTROINTESTINAL_SYSTEM_ID: {
      mcpId: 650,
      field: "GASTROINTESTINAL_SYSTEM_ID",
      scoreField: "GASTROINTESTINAL_SYSTEM_ID",
    },
    CARDIOVASCULAR_SYSTEM_ID: {
      mcpId: 651,
      field: "CARDIOVASCULAR_SYSTEM_ID",
      scoreField: "CARDIOVASCULAR_SYSTEM_ID",
    },
    RENAL_SYSTEM_ID: {
      mcpId: 652,
      field: "RENAL_SYSTEM_ID",
      scoreField: "RENAL_SYSTEM_ID",
    },
    ACID_BASE_BALANCE_ID: {
      mcpId: 653,
      field: "ACID_BASE_BALANCE_ID",
      scoreField: "ACID_BASE_BALANCE_ID",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    NS_ID: "",
    PROCESS_TIME: new Date(),
    NURSE_ID: "",
    CTIME: new Date(),
    CUSER: "",
    CALC_VALUE: "",
    MORTALITY_RATIO: "",
    CENTRAL_NERVOUS_SYSTEM_ID: "",
    HEMOCOAGULATION_BALANCE_ID: "",
    RESPIRATORY_SYSTEM_ID: "",
    GASTROINTESTINAL_SYSTEM_ID: "",
    CARDIOVASCULAR_SYSTEM_ID: "",
    RENAL_SYSTEM_ID: "",
    ACID_BASE_BALANCE_ID: "",
  },
  chartScoreField: "CALC_VALUE",
  chartTimeField: "PROCESS_TIME",
};


